import { Action, Reducer } from 'redux';

import * as Actions from '../../actions';
import { SettlementState, SettlementUnloadState } from '../../states/SettlementState';
import { Settlement } from '../../../models/Entities/Settlements/Settlement';

type KnownAction =
    | Actions.Settlements.Settlement_GetDebtsBySettlementId_Request_Action
    | Actions.Settlements.Settlement_GetDebtsBySettlementId_Receive_Action
    | Actions.Settlements.Settlement_GetDebtsBySettlementId_Fail_Action
    | Actions.CashFlowDebts.CashFlowDebtGetBySettlementIdRequestAction
    | Actions.CashFlowDebts.CashFlowDebtGetBySettlementIdSuccessAction
    | Actions.CashFlowDebts.CashFlowDebtGetBySettlementIdFailureAction;

export const SettlementDebtsReducer: Reducer<SettlementState> = (
    state: SettlementState | undefined,
    incomingAction: Action
): SettlementState => {
    if (state === undefined) {
        return SettlementUnloadState as SettlementState;
    }

    const action = incomingAction as KnownAction;

    var CurrentSettlement: Settlement | undefined = undefined;

    switch (action.type) {
        case 'SETTLEMENT_GETDEBTSBYSETTLEMENTID_REQUEST_ACTION':

            CurrentSettlement = state.list && state.list.length > 0 ? state.list.find((settlement: Settlement) => settlement.id === action.settlementId) : undefined;

            if (CurrentSettlement) {
                CurrentSettlement.isGettingDebts = true;
                CurrentSettlement.isGettingDebtsSuccess = undefined;
                CurrentSettlement.failOnGettingDebts = false;
                CurrentSettlement.ErrorGettingDebts = undefined;
            }

            return {
                ...state,
                list: CurrentSettlement ? [...state.list!.filter((settlement: Settlement) => settlement.id !== action.settlementId), CurrentSettlement] : state.list,
                
            };
        case 'SETTLEMENT_GETDEBTSBYSETTLEMENTID_RECEIVE_ACTION':

            CurrentSettlement = state.list && state.list.length > 0 ? state.list.find((settlement: Settlement) => settlement.id === action.settlementId) : undefined;

            if (CurrentSettlement) {
                CurrentSettlement.isGettingDebts = false;
                CurrentSettlement.isGettingDebtsSuccess = true;
                CurrentSettlement.failOnGettingDebts = false;
                CurrentSettlement.ErrorGettingDebts = undefined;
                CurrentSettlement.debts = action.debts;
            }

            return {
                ...state,
                list: CurrentSettlement ? [...state.list!.filter((settlement: Settlement) => settlement.id !== action.settlementId), CurrentSettlement] : state.list,
                
            };
        case 'SETTLEMENT_GETDEBTSBYSETTLEMENTID_FAIL_ACTION':

            CurrentSettlement = state.list && state.list.length > 0 ? state.list.find((settlement: Settlement) => settlement.id === action.settlementId) : undefined;

            if (CurrentSettlement) {
                CurrentSettlement.isGettingDebts = false;
                CurrentSettlement.isGettingDebtsSuccess = false;
                CurrentSettlement.failOnGettingDebts = true;
                CurrentSettlement.ErrorGettingDebts = action.error;
            }

            return {
                ...state,
                list: CurrentSettlement ? [...state.list!.filter((settlement: Settlement) => settlement.id !== action.settlementId), CurrentSettlement] : state.list,
            };
        case 'CASHFLOW-DEBT_GETBYSETTLEMENTID_REQUEST':

            CurrentSettlement = state.list && state.list.length > 0 ? state.list.find((settlement: Settlement) => settlement.id === action.settlementId) : undefined;

            if (CurrentSettlement) {
                CurrentSettlement.isGettingDebts = true;
                CurrentSettlement.isGettingDebtsSuccess = undefined;
                CurrentSettlement.failOnGettingDebts = false;
                CurrentSettlement.ErrorGettingDebts = undefined;
            }

            return {
                ...state,
                list: CurrentSettlement ? [...state.list!.filter((settlement: Settlement) => settlement.id !== action.settlementId), CurrentSettlement] : state.list,
            };
        case 'CASHFLOW-DEBT_GETBYSETTLEMENTID_SUCCESS':

            CurrentSettlement = state.list && state.list.length > 0 ? state.list.find((settlement: Settlement) => settlement.id === action.settlementId) : undefined;

            if (CurrentSettlement) {
                CurrentSettlement.isGettingDebts = false;
                CurrentSettlement.isGettingDebtsSuccess = true;
                CurrentSettlement.failOnGettingDebts = false;
                CurrentSettlement.ErrorGettingDebts = undefined;
                
                // Actualizar las deudas existentes o crear nuevas basándose en el payload
                if (action.payload && action.payload.length > 0) {
                    if (CurrentSettlement.debts && CurrentSettlement.debts.length > 0) {
                        // Enriquecer deudas existentes con detalles CashFlow
                        CurrentSettlement.debts = CurrentSettlement.debts.map(existingDebt => {
                            const updatedDebt = action.payload.find(payloadDebt => payloadDebt.id === existingDebt.debtId);
                            if (updatedDebt) {
                                return {
                                    ...existingDebt,
                                    CashFlowDebt: updatedDebt
                                };
                            }
                            return existingDebt;
                        });
                        CurrentSettlement.debts = [...CurrentSettlement.debts];
                    } else {
                        // Si no hay deudas base aún, crear elementos SettlementDebt a partir del payload
                        CurrentSettlement.debts = action.payload.map(payloadDebt => ({
                            id: payloadDebt.id,
                            settlementId: action.settlementId,
                            debtId: payloadDebt.id,
                            CashFlowDebt: payloadDebt
                        }));
                    }
                }
            }

            return {
                ...state,
                list: CurrentSettlement ? [...state.list!.filter((settlement: Settlement) => settlement.id !== action.settlementId), CurrentSettlement] : state.list,
            };
        case 'CASHFLOW-DEBT_GETBYSETTLEMENTID_FAILURE':

            CurrentSettlement = state.list && state.list.length > 0 ? state.list.find((settlement: Settlement) => settlement.id === action.settlementId) : undefined;

            if (CurrentSettlement) {
                CurrentSettlement.isGettingDebts = false;
                CurrentSettlement.isGettingDebtsSuccess = false;
                CurrentSettlement.failOnGettingDebts = true;
                CurrentSettlement.ErrorGettingDebts = action.error;
            }

            return {
                ...state,
                list: CurrentSettlement ? [...state.list!.filter((settlement: Settlement) => settlement.id !== action.settlementId), CurrentSettlement] : state.list,
            };
        default:
            return state;
    }
};
